import {Validator} from 'jsonschema'
export const validate = (i,s) => {
  const v = new Validator()
  return v.validate(i,s).errors.map(e=>e.stack)
}